type LegalDocumentModalProps = {
  title: string;
  content: string;
  labels: {
    close: string;
    openExternal: string;
    lastUpdated: string;
  };
  onClose: () => void;
  onOpenExternal: () => void;
};

export function LegalDocumentModal({ title, content, labels, onClose, onOpenExternal }: LegalDocumentModalProps) {
  const sections = content
    .split('\n\n')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);

  return (
    <div className="sheet-overlay" onClick={onClose}>
      <div className="sheet onboarding-sheet legal-doc-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-header">
          <h3>{title}</h3>
          <button onClick={onClose}>{labels.close}</button>
        </div>
        <div className="small legal-doc-updated">{labels.lastUpdated}</div>
        <div className="card legal-doc-content">
          {sections.map((section, index) => (
            <p key={`legal-section-${index}`}>{section}</p>
          ))}
        </div>
        <div className="timer-buttons onboarding-actions">
          <button onClick={onOpenExternal}>{labels.openExternal}</button>
          <button onClick={onClose}>{labels.close}</button>
        </div>
      </div>
    </div>
  );
}
